import { ReactNode } from "react";

interface PageLayoutProps {
  children: ReactNode;
  maxWidth?: string;
  centered?: boolean;
  /** Opt-in wider container for desktop-rich pages (e.g. signed-out home). */
  wide?: boolean;
  /** Drop the bottom-nav padding gap on surfaces where the bottom nav is hidden
   *  (signed-out marketing surfaces, /auth, /404, /v/:id permalinks). */
  noBottomNav?: boolean;
  /** Deprecated: header brand was removed app-wide. Prop kept for compatibility. */
  showBrandHeader?: boolean;
}

export default function PageLayout({
  children,
  maxWidth,
  centered = false,
  wide = false,
  noBottomNav = false,
}: PageLayoutProps) {
  const container = maxWidth ?? (wide ? "max-w-5xl" : "max-w-2xl");
  const bottomPad = noBottomNav ? "pb-12" : "pb-[96px]";
  return (
    <div className={`min-h-screen bg-background text-foreground pt-safe ${bottomPad} overflow-x-hidden ${centered ? "flex items-center justify-center px-5" : ""}`}>
      {centered ? (
        children
      ) : (
        <div className={`${container} mx-auto px-4 sm:px-5 pt-8 md:pt-12`}>
          {children}
        </div>
      )}
    </div>
  );
}
